/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowRequestManagementCatalogDetails {
    getFixupPrototypeFunction() { return ServiceNowRequestManagementCatalogDetails.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowRequestManagementCatalogDetails>): ServiceNowRequestManagementCatalogDetails {
        let obj = Object.assign(new ServiceNowRequestManagementCatalogDetails(), model);
        ServiceNowRequestManagementCatalogDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowRequestManagementCatalogDetails>): ServiceNowRequestManagementCatalogDetails {
        if (!model) return null;
        return ServiceNowRequestManagementCatalogDetails.newInstance(<ServiceNowRequestManagementCatalogDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowRequestManagementCatalogDetails) {
        if (!obj) return;

        models.ServiceNowRequestManagementCatalogDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowRequestManagementCatalogDetails): boolean {
        Object.setPrototypeOf(obj, ServiceNowRequestManagementCatalogDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.service_now_catalog) {
            models.ServiceNowRequestManagementCatalogComponent.fixupPrototype(this.service_now_catalog);
        }
        if (this.service_now_category) {
            models.ServiceNowRequestManagementCatalogComponent.fixupPrototype(this.service_now_category);
        }
        if (this.service_now_subcategory) {
            models.ServiceNowRequestManagementCatalogComponent.fixupPrototype(this.service_now_subcategory);
        }
        if (this.service_now_item) {
            models.ServiceNowRequestManagementCatalogComponent.fixupPrototype(this.service_now_item);
        }
        if (this.corestack_catalog) {
            models.ServiceNowRequestManagementCatalogComponent.fixupPrototype(this.corestack_catalog);
        }
        if (this.corestack_category) {
            models.ServiceNowRequestManagementCatalogComponent.fixupPrototype(this.corestack_category);
        }
        if (this.corestack_resource) {
            models.ServiceNowRequestManagementCatalogComponent.fixupPrototype(this.corestack_resource);
        }
        if (this.corestack_item) {
            models.ServiceNowRequestManagementCatalogComponent.fixupPrototype(this.corestack_item);
        }
    }

    /**
     * ServiceNow catalog  for Request management catalog
     */
    service_now_catalog: models.ServiceNowRequestManagementCatalogComponent;

    /**
     * ServiceNow category for Request management catalog
     */
    service_now_category: models.ServiceNowRequestManagementCatalogComponent;

    /**
     * ServiceNow subcategory for Request management catalog
     */
    service_now_subcategory: models.ServiceNowRequestManagementCatalogComponent;

    /**
     * ServiceNow Item attribute for Request management catalog
     */
    service_now_item: models.ServiceNowRequestManagementCatalogComponent;

    /**
     * Corestack catalog  for Request management catalog
     */
    corestack_catalog: models.ServiceNowRequestManagementCatalogComponent;

    /**
     * Corestack category for Request management catalog
     */
    corestack_category: models.ServiceNowRequestManagementCatalogComponent;

    /**
     * Corestack resource for Request management catalog
     */
    corestack_resource: models.ServiceNowRequestManagementCatalogComponent;

    /**
     * Corestack Item attribute for Request management catalog
     */
    corestack_item: models.ServiceNowRequestManagementCatalogComponent;

}
